import React from "react";
import { Link } from "react-router-dom";
import { navLinks } from "../../data/mockData";

const FooterLinks = () => (
  <div>
    <h4 className="text-[#C9A96E] font-serif text-lg font-semibold mb-6">
      Quick Links
    </h4>
    <ul className="space-y-3">
      {navLinks.map((link) => (
        <li key={link.name}>
          <Link
            to={link.path}
            className="text-white/60 hover:text-white text-sm transition-colors duration-300"
          >
            {link.name}
          </Link>
        </li>
      ))}
    </ul>
  </div>
);

export { FooterLinks };
